export default __webpack_public_path__ + "static/contractors-ff0f1f43db83291eb2fd12be4de4fd2b.png";